var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"overlay"},[_c('div',{staticClass:"loadingGraphic"},[_c('img',{staticClass:"loadingGIF",attrs:{"src":require("../../assets/img/loader.gif"),"alt":"Loading icon"}})])])
}]

export { render, staticRenderFns }